import React from 'react';
import {
  Box,
  Container,
  Flex,
  Heading,
  Text,
  Button,
  Stack,
} from '@chakra-ui/react';
import heroImage from '../../../assets/images/hero-400x400.png';
import { HeroPresentationProps } from '../types';
import { SectionAnchor } from '../../../shared/components';

const HeroPresentation: React.FC<HeroPresentationProps> = ({
  id,
  content,
  onPrimaryButtonClick,
  onSecondaryButtonClick
}) => {
  return (
    <>
      <SectionAnchor id={id} />
      <Box 
        as="section"
        minH="90vh" 
        bgGradient="linear(to-r, brand.primary.dark, brand.secondary.base)"
        pt={{ base: 4, md: 6 }} pb={{ base: 8, md: 12 }}
        display="flex"
        alignItems="center"
      >
      <Container maxW="container.xl">
        <Flex 
          direction={{ base: 'column', md: 'row' }} 
          align="center" 
          justify="space-between"
          gap={8}
        >
          <Stack spacing={6} maxW="600px">
            <Heading 
              as="h1" 
              size="3xl" 
              color="white" 
              fontWeight="bold" 
              lineHeight="1.2"
            >
              {content.headline} <br />
              <Box as="span" color="brand.primary.base">
                {content.highlightedText}
              </Box>
            </Heading>
            <Text fontSize="xl" color="white" opacity={0.9}>
              {content.description}
            </Text>
            <Stack direction={{ base: 'column', sm: 'row' }} spacing={4} align="flex-start">
              <Button 
                size="lg"
                as="a"
                href={content.primaryButtonLink}
                onClick={onPrimaryButtonClick}
              >
                {content.primaryButtonText}
              </Button>
              <Button 
                size="lg" 
                variant="secondary"
                as="a"
                href={content.secondaryButtonLink}
                onClick={onSecondaryButtonClick}
              >
                {content.secondaryButtonText}
              </Button>
            </Stack>
          </Stack>
          
          <Box 
            w={{ base: "full", md: "500px" }} 
            h={{ base: "300px", md: "400px" }} 
            bg="white" 
            borderRadius="xl" 
            boxShadow="xl"
            overflow="hidden"
            position="relative"
          >
            <Box
              as="img"
              src={heroImage}
              alt="AZ1.AI Hero"
              width="100%"
              height="100%"
              objectFit="cover"
            />
          </Box>
        </Flex>
      </Container>
    </Box>
    </>
  );
};

export default HeroPresentation;